import { render, staticRenderFns } from "./CatalogueHome.vue?vue&type=template&id=44fab3aa&scoped=true&"
import script from "./CatalogueHome.vue?vue&type=script&lang=js&"
export * from "./CatalogueHome.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueHome.vue?vue&type=style&index=0&id=44fab3aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fab3aa",
  null
  
)

export default component.exports